import React from "react";
import { formatNumber } from "@danishagro/shared/src/helpers/formatNumber.helper";
import { useTranslations } from "@danishagro/shared/src/contexts/translations/translations.context";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { Helmet } from "react-helmet";
import S from "./DiscountTableMobile.module.scss";

interface DiscountRow {
    quantityFrom: number;
    quantityTo?: number;
    price: number;
}

interface DiscountTableProps {
    discountTable: DiscountRow[];
    priceCurrency?: string;
}

export const DiscountTableMobile = ({ discountTable, priceCurrency }: DiscountTableProps) => {
    const { getDictionaryString } = useTranslations();
    const { currentCulture } = useAppData();

    const structuredData = {
        "@context": "https://schema.org",
        "@type": "AggregateOffer",
        offers: discountTable.map((item) => ({
            "@type": "Offer",
            price: formatNumber(item.price, currentCulture, { decimals: 2 }),
            priceCurrency: priceCurrency,
            eligibleQuantity: {
                "@type": "QuantitativeValue",
                value: item.quantityFrom,
            },
        })),
    };

    return (
        <div className={S.discountTable}>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            </Helmet>
            {discountTable.map((item, index) => (
                <div className={S.discountTableItem} key={index}>
                    <span className={S.amount}>{`${item.quantityFrom} ${getDictionaryString(
                        "pcs"
                    )}`}</span>
                    <span className={S.pricePerPcs}>
                        {getDictionaryString("discount.pricePerPcs")}
                    </span>
                    <span className={S.price}>
                        {formatNumber(item.price, currentCulture, {
                            decimals: 2,
                        })}
                    </span>
                </div>
            ))}
        </div>
    );
};
